import * as React from 'react'

export const Linkedin = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H21C23.2091 24 25 22.2091 25 20V4C25 1.79086 23.2091 0 21 0H4ZM13.4049 9.72675H10.4646V19.5H13.6313V14.7653C13.6313 13.179 14.2528 12.1702 15.7482 12.1702C16.8265 12.1702 17.25 13.1062 17.25 14.766V19.5H20.4167V14.1023C20.4167 11.1877 19.6741 9.59925 16.5462 9.59925C14.9146 9.59925 13.8284 10.3162 13.4049 11.1143V9.72675ZM8.20125 19.3725H5.03458V9.59925H8.20125V19.3725ZM8.50002 7.14494C8.60235 6.91293 8.65499 6.66396 8.65488 6.4125C8.65488 5.90475 8.44033 5.41875 8.05875 5.06025C7.67638 4.70175 7.15863 4.5 6.61871 4.5C6.07977 4.49978 5.56253 4.70112 5.17946 5.06025C4.79708 5.41875 4.58333 5.90475 4.58333 6.4125C4.58379 6.66392 4.63661 6.91278 4.73877 7.14482C4.84093 7.37687 4.99042 7.58753 5.17867 7.76475C5.56208 8.1234 6.0791 8.32466 6.61792 8.325C7.15768 8.32624 7.6759 8.12447 8.05875 7.764C8.24768 7.58738 8.39768 7.37695 8.50002 7.14494Z"
      fill="white"
    />
  </svg>
)
